// Disable after public launch to restore registration and customer routes.
export const PUBLIC_PRELAUNCH = true;

export const PUBLIC_CONTACT_EMAIL = 'office@allkey.ro';
